import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lightbulb } from 'lucide-react';
import { useTranslation } from '@/components/utils/translations';

export default function InitiativesCard({ initiatives }) {
  const { t } = useTranslation();
  
  return (
    <Card className="border-0 shadow-md">
      <CardHeader>
        <div className="flex items-center gap-2">
            <Lightbulb className="w-4 h-4 text-[#00C2C2]" />
            <CardTitle className="text-lg font-semibold text-[#0A1A2F]">{t('atAGlance')}</CardTitle>
        </div>
        <p className="text-sm text-[#5C6B7A]">{t('keyInitiatives')}</p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
            {initiatives && initiatives.length > 0 ? (
                initiatives.map(item => <Badge key={item} variant="secondary">{item}</Badge>)
            ) : (
                <p className="text-sm text-gray-500">{t('noInitiatives')}</p>
            )}
        </div>
      </CardContent>
    </Card>
  );
}